export default {
  pt: {
    'cadastros.resourceFormPage.updated': '{{resource}} atualizado.',
    'cadastros.resourceFormPage.created': '{{resource}} criado.',
    'cadastros.resourceFormPage.editTitle': 'Editar {{resource}}',
    'cadastros.resourceFormPage.newTitle': 'Novo {{resource}}',
  },
  en: {
    'cadastros.resourceFormPage.updated': '{{resource}} updated.',
    'cadastros.resourceFormPage.created': '{{resource}} created.',
    'cadastros.resourceFormPage.editTitle': 'Edit {{resource}}',
    'cadastros.resourceFormPage.newTitle': 'New {{resource}}',
  },
  es: {
    'cadastros.resourceFormPage.updated': '{{resource}} actualizado.',
    'cadastros.resourceFormPage.created': '{{resource}} creado.',
    'cadastros.resourceFormPage.editTitle': 'Editar {{resource}}',
    'cadastros.resourceFormPage.newTitle': 'Nuevo {{resource}}',
  },
}
